export default __webpack_public_path__ + "static/media/16.4a33e6d9.png";